// Domaine de production : à modifier ici uniquement
export const SITE_URL = "https://marabout-orleans.fr";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export const BUSINESS = {
  name: "Maître Diamma",
  phone: "07 45 44 96 41",
  phoneIntl: "+33745449641",
  street: "12 Rue de Bourgogne",
  city: "Orléans",
  cp: "45000",
  lat: 47.9017,
  lng: 1.911
};

const businessId = `${SITE_URL}/#business`;

export function businessNode(villes) {
  return {
    "@type": ["LocalBusiness", "ProfessionalService"],
    "@id": businessId,
    "name": "Maître Diamma — Marabout & Sorcier puissant à Orléans",
    "alternateName": ["Maître Diamma", "Marabout Diamma", "Marabout Orléans 45"],
    "description": "Grand marabout africain, sorcier puissant, voyant médium et guérisseur à Orléans : retour affectif, désenvoûtement, anti-sorcellerie, magie blanche et voyance à Orléans, dans la métropole, le Loiret et les villes voisines.",
    "url": `${SITE_URL}/`,
    "image": OG_IMAGE,
    "telephone": BUSINESS.phoneIntl,
    "priceRange": "€€",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": BUSINESS.street,
      "addressLocality": BUSINESS.city,
      "postalCode": BUSINESS.cp,
      "addressRegion": "Centre-Val de Loire",
      "addressCountry": "FR"
    },
    "geo": { "@type": "GeoCoordinates", "latitude": BUSINESS.lat, "longitude": BUSINESS.lng },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "08:00",
      "closes": "22:00"
    },
    "areaServed": [
      { "@type": "AdministrativeArea", "name": "Loiret" },
      { "@type": "AdministrativeArea", "name": "Orléans Métropole" },
      ...villes.map((v) => ({ "@type": "City", "name": v.nom }))
    ],
    "knowsAbout": ["Marabout", "Sorcier puissant", "Sorcellerie", "Désenvoûtement", "Retour affectif", "Magie blanche", "Voyance", "Médium", "Guérisseur africain", "Protection spirituelle"],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de Maître Diamma",
      "itemListElement": ["Retour affectif", "Désenvoûtement et anti-sorcellerie", "Sorcier puissant", "Magie blanche", "Voyance et médiumnité", "Guérison traditionnelle africaine", "Protection spirituelle", "Chance et prospérité"].map((n) => ({
        "@type": "Offer",
        "itemOffered": { "@type": "Service", "name": n, "areaServed": "Orléans" }
      }))
    }
  };
}

export function webPageNode(path, title, description) {
  return {
    "@type": "WebPage",
    "@id": `${SITE_URL}${path}#webpage`,
    "url": `${SITE_URL}${path}`,
    "name": title,
    "description": description,
    "inLanguage": "fr-FR",
    "isPartOf": { "@id": `${SITE_URL}/#website` },
    "about": { "@id": businessId },
    "primaryImageOfPage": OG_IMAGE
  };
}

export function websiteNode() {
  return {
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    "url": `${SITE_URL}/`,
    "name": "Maître Diamma — Marabout Orléans",
    "inLanguage": "fr-FR",
    "publisher": { "@id": businessId }
  };
}

export function breadcrumbNode(items) {
  return {
    "@type": "BreadcrumbList",
    "itemListElement": items.map((it, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": it.name,
      "item": `${SITE_URL}${it.path}`
    }))
  };
}

export function faqNode(faqs) {
  return {
    "@type": "FAQPage",
    "mainEntity": faqs.map((f) => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  };
}

export function serviceNode(path, name, areaName, v) {
  const city = { "@type": "City", "name": areaName, "containedInPlace": { "@type": "AdministrativeArea", "name": "Loiret, Centre-Val de Loire" } };
  if (v) {
    city.postalCode = v.cp;
    city.geo = { "@type": "GeoCoordinates", "latitude": v.lat, "longitude": v.lng, "postalCode": v.cp, "addressCountry": "FR" };
  }
  return {
    "@type": "Service",
    "name": name,
    "serviceType": name,
    "url": `${SITE_URL}${path}`,
    "provider": { "@id": businessId },
    "availableChannel": { "@type": "ServiceChannel", "servicePhone": { "@type": "ContactPoint", "telephone": BUSINESS.phoneIntl, "contactType": "customer service", "areaServed": areaName, "availableLanguage": "French" } },
    "areaServed": v ? [city, { "@type": "GeoCircle", "geoMidpoint": { "@type": "GeoCoordinates", "latitude": v.lat, "longitude": v.lng }, "geoRadius": "15000" }] : city
  };
}

export function geoMeta(v) {
  const p = v || { nom: BUSINESS.city, cp: BUSINESS.cp, lat: BUSINESS.lat, lng: BUSINESS.lng };
  return { region: `FR-${p.cp.slice(0, 2)}`, placename: `${p.nom} (${p.cp})`, position: `${p.lat};${p.lng}`, icbm: `${p.lat}, ${p.lng}` };
}

export function articleNode(path, a) {
  return {
    "@type": "BlogPosting",
    "headline": a.title,
    "description": a.description,
    "datePublished": a.date,
    "dateModified": a.date,
    "inLanguage": "fr-FR",
    "image": OG_IMAGE,
    "mainEntityOfPage": `${SITE_URL}${path}`,
    "author": { "@type": "Person", "name": "Maître Diamma" },
    "publisher": { "@id": businessId }
  };
}
